<template>
	<div>
		<img class="personalbg" src="../../../static/images/mobile/personal-bg.png" alt="" />
		<div class="personaltop" style="display: flex">
			<van-image round :src="picture" @click="modifyInformation" />
			<div style="z-index: 99">
				<div class="personalname">{{ name }}</div>
				<div class="personalnumber">{{ mobile }}</div>
			</div>
		</div>
		<div class="personalClass">
			<van-grid clickable :column-num="2">
				<van-grid-item @click="goMyStudy()" class="personalclass" icon="../../../static/images/mobile/personalclass.png" text="我的班级" />
				<van-grid-item class="personalclass" icon="../../../static/images/mobile/personallesson.png" text="自选课程" to="/mobileClassRoom" />
			</van-grid>
		</div>
		<div class="personalClass">
			<van-cell class="mobileMyIcon" icon="../../../static/images/mobile/exam.png" title="我的考试" is-link to="/mobileExamList" />
			<van-cell
				class="mobileAuthentication mobileMyIcon"
				icon="../../../static/images/mobile/authentication2.png"
				title="实名认证"
				is-link
				to="/mobileAuthentication"
			/>
			<van-cell class="mobileMyIcon" icon="../../../static/images/mobile/personalmessage.png" title="我的消息" is-link to="/mobileNews" />
			<van-cell class="mobileMyIcon" @click="clientService()" icon="../../../static/images/mobile/personalservice.png" title="在线客服" is-link />
			<van-cell class="mobileSet mobileMyIcon" icon="../../../static/images/mobile/personalset.png" title="设置" is-link to="/mobileSet" />
		</div>
		<van-tabbar fixed v-model="active">
			<van-tabbar-item to="/mobileHome">
				<span>首页</span>
				<template #icon="props">
					<img :src="props.active ? index.active : index.inactive" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item to="/mobileStudy">
				<span>班级</span>
				<template #icon="props">
					<img :src="props.active ? classes.active : classes.inactive" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item to="/mobileMy">
				<span>我的</span>
				<template #icon="props">
					<img :src="props.active ? my.active : my.inactive" />
				</template>
			</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
import { Toast } from "vant";
export default {
	data() {
		return {
			name: "",
			mobile: "",
			picture: "",
			active: 2,
			index: {
				active: "../../../static/images/mobile/onIndex.png",
				inactive: "../../../static/images/mobile/index.png",
			},
			classes: {
				active: "../../../static/images/mobile/onClass.png",
				inactive: "../../../static/images/mobile/class.png",
			},
			my: {
				active: "../../../static/images/mobile/onMy.png",
				inactive: "../../../static/images/mobile/my.png",
			}, //table栏
		};
	},
	methods: {
		clientService() {
			$("#udesk_btn_text").trigger("click");
		},
		/**
		 * 获取个人信息
		 */
		judgeLogin() {
			if (localStorage.getItem("loginUrl")) {
				this.getUserInfor();
			} else {
				Toast("请先登录");
				this.$router.push({ path: "/mobileLogin" });
			}
		},
		getUserInfor() {
			this.$api.get("/user/getUserDetail", null, (res) => {
				if (status == 0) {
					this.name = res.data.realName;
					this.mobile = res.data.mobile;
					this.picture = res.data.picture;
				}
			});
		},
		modifyInformation() {
			this.$router.push({ path: "/mobilePersonalMessage" });
		},
		goMyStudy() {
			this.$router.push({ path: "/mobileStudy", query: { active: 2 } });
		},
	},
	mounted() {
		this.judgeLogin();
	},
	created() {
		(function (a, h, c, b, f, g) {
			a["UdeskApiObject"] = f;
			a[f] =
				a[f] ||
				function () {
					(a[f].d = a[f].d || []).push(arguments);
				};
			g = h.createElement(c);
			g.async = 1;
			g.charset = "utf-8";
			g.src = b;
			c = h.getElementsByTagName(c)[0];
			c.parentNode.insertBefore(g, c);
		})(window, document, "script", "https://assets-cli.s4.udesk.cn/im_client/js/udeskApi.js", "ud");
		ud({
			code: "2jhbcbc",
			link: "https://clkefu.s4.udesk.cn/im_client/?web_plugin_id=25019 ",
		});
	},
	beforeCreate() {
		document.querySelector("body").setAttribute("style", "background:#eee");
	}, //
	beforeDestroy() {
		document.querySelector("body").removeAttribute("style");
	},
};
</script>
<style >
.personalclass .van-grid-item__text {
	font-size: 0.373333rem;
	font-weight: 500;
	color: #000000;
}
.personalclass .van-icon__image {
	width: 0.746667rem;
	height: 0.746667rem;
}
.mobileMyIcon .van-icon__image {
	width: 0.5333rem;
	height: 0.5333rem;
}
/* .mobileMyIcon  {
	display: flex;
	align-items: center;
} */
</style>
<style scoped>
.body {
	background-color: #f2f2f2;
}
.van-cell {
	align-items: baseline;
}
.personaltop {
	padding-top: 0.773333rem;
	margin-left: 0.426667rem;
	margin-bottom: 0.64rem;
}
.van-image {
	width: 1.6rem;
	height: 1.6rem;
	margin-right: 0.32rem;
}
.personalnumber {
	font-weight: 400;
	font-size: 0.373333rem;
	color: #fefefe;
	opacity: 0.5;
}
.personalname {
	font-size: 0.48rem;
	color: #ffffff;
	font-weight: bold;
	margin-bottom: 0.08rem;
}
.personalClass {
	padding-left: 0.426667rem;
	padding-right: 0.426667rem;
	margin-bottom: 0.426667rem;
}
.personalbg {
	width: 100%;
	height: 4.16rem;
	position: absolute;
}
.van-cell {
	height: 1.6rem;
	padding: 0.533333rem 0.533333rem;
}
.mobileSet {
	border-radius: 0 0 0.106667rem 0.106667rem;
}
.mobileAuthentication {
	border-radius: 0.106667rem 0.106667rem 0 0;
}
</style>


// WEBPACK FOOTER //
// MobileMy.vue?740e2518